import { Component, OnInit } from '@angular/core';
import { FormGroup ,FormControl, Validators } from "@angular/forms";
import { CursoService } from "../../servicios/curso.service";
import { cursoI } from 'src/app/shared/models/curso.interface';

@Component({
  selector: 'app-nuevo-curso',
  templateUrl: './nuevo-curso.component.html',
  styleUrls: ['./nuevo-curso.component.scss']
})
export class NuevoCursoComponent implements OnInit {

  private archivo:any;

  constructor(private cursoSvc:CursoService) { }

  public newCursoForm = new FormGroup({
    titulo: new FormControl("", Validators.required),
    content: new FormControl("", Validators.required),
    tags: new FormControl("", Validators.required),
    imagen: new FormControl("", Validators.required),
    creador: new FormControl("", Validators.required),
  })

  ngOnInit(): void {
  }


  addCurso(data:cursoI)
  {
    data.videos = [];
    //console.log("data", data);
    //console.log("archivo", this.archivo)

    //IMPORTANTEEEE
    this.cursoSvc.preAddUpdateCurso(data, this.archivo);
  }

  handleArchivo(e)
  {
    //comenzar a modificar aca cuando necesite subir mas archivos!!!!!
    //!importanteeeeeeeeeeeeeeeeeeeeeeeeee

    this.archivo = e.target.files[0];
    //console.log(this.archivo)
  }
}
